function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Box, DropButton } from 'grommet';
// import Avatar from 'granite-admin/core/components/Avatar'
import MenuButton from 'granite-admin/core/components/MenuButton';
import PropType from 'prop-types';
const DropMenu = ({
  hoverIndicatorOptions,
  label,
  icon,
  renderItems,
  isCollapsed,
  dropAlign,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(DropButton, _extends({
    dropAlign: dropAlign || {
      top: 'bottom',
      right: 'right'
    },
    dropContent: renderItems(),
    elevation: "medium"
  }, rest), /*#__PURE__*/React.createElement(MenuButton, {
    isCollapsed: isCollapsed,
    label: label,
    hoverIndicatorOptions: hoverIndicatorOptions,
    icon: icon
  })));
};
DropMenu.defaultProps = {
  isCollapsed: true,
  profile: {},
  renderItems: null
};
DropMenu.propTypes = {
  isCollapsed: PropType.bool,
  profile: PropType.object,
  renderItems: PropType.func,
  dropAlign: PropType.object
};
export default DropMenu;